import React, {Component} from "react";

import {View, Text, StyleSheet, ActivityIndicator}  from 'react-native'

import cores from '../util/cores'

import {estilos} from '../util/estilos'

import {Picker} from '@react-native-picker/picker'

import * as util from '../util/util'

import * as texto from '../util/texto'




export default class Combo extends Component {


    constructor(props) {
        
        super(props);
		
		this.state = {
            valores:          util.temPropriedade(this.props, "dados")  && this.props.dados!==null?this.props.dados:[],
            selecionado:      props.selecionado,
            carregando:       false,
            mostrarVazio:     !util.temPropriedade(props, "mostrarVazio") || (util.temPropriedade(props, "mostrarVazio") && props.mostrarVazio),
            rotuloVazio:      texto.isBlanck(props.rotuloVazio)?'...':props.rotuloVazio
        };
    }


    setDados(valores){

        this.setState({valores: valores});
    }


    setDadosComSelecionado(valores, selecionado){

        this.setState({ valores:        valores, 
                        selecionado:    selecionado });
    }


    setCarregando(valor){

        this.setState({carregando: valor});
    }


    getSelecionado(){

        return this.state.selecionado;
    }


    getItemSelecionado(){

        let aux = null;

        this.state.valores.forEach(item => {
            if(item.id ==  this.state.selecionado)
                aux =  item
        });

        return aux !=null?aux:null;
    }


    setIdSelecionado(id_selecionado){

        this.setState({valores: this.state.valores, selecionado:    id_selecionado });   
    }


    render() {
        
        if(this.state.carregando)
            return (
                <View style={styles.carregando}>
                    <ActivityIndicator size="large" color={cores.laranja_regin} animating={this.state.carregando}/>
                </View>)

        return (
            <View style={styles.area_geral}>
                <Text style={estilos.rotulo_padrao}>{this.props.rotulo}</Text>
                
                <View style={estilos.combo_padrao}>
                    <Picker
                        selectedValue={this.state.selecionado!=null?this.state.selecionado:null}
                        onValueChange={(valor, index)=>{
                            
                            let aux = null;

                            this.state.valores.forEach(item => {
                                if(item.id == valor)
                                    aux =  item
                            });
                    
                            if(aux !=null){
                                 
                                this.setState({selecionado: aux.id})
                
                                if(util.temPropriedade(this.props, "aoMudar")  && this.props.aoMudar!==null)
                                    this.props.aoMudar(aux)
                            }
                        }}
                        style={{margin:0, padding:0, height:44, fontSize: 14}}
                        >

                        { this.state.mostrarVazio && 

                            <Picker.Item label={this.state.rotuloVazio} value= {null} key="ND"/>
                        }

                        {  
                            this.state.valores.map(item=>{

                                return( <Picker.Item style={estilos.combo_padrao} label={item.nome} value= {item.id} key={item.id} />)

                            })  
                        }
                    </Picker>
                </View> 
            </View>
        )
   }
} 



const styles = StyleSheet.create({

    carregando:{

        flex:1,
        alignItems:'center',
        padding: 19
    }
})



